import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PdfViewerComponent } from './pdf-viewer.component';
import {NgxExtendedPdfViewerModule} from "ngx-extended-pdf-viewer";
import {NzButtonModule} from "ng-zorro-antd/button";
import {NzIconModule} from "ng-zorro-antd/icon";



@NgModule({
  declarations: [
    PdfViewerComponent
  ],
  imports: [
    CommonModule,
    NgxExtendedPdfViewerModule,
    NzButtonModule,
    NzIconModule
  ]
})
export class PdfViewerModule { }
